export default __webpack_public_path__ + "static/media/BrownBorder.728a3934.svg";